import styled from "styled-components";

export const ConfirmModalActionRow = styled.div.attrs({
  className: "flex flex-wrap justify-end gap-3",
})``;

export const ConfirmModalSecondaryButton = styled.button.attrs({
  className: "brand-button-secondary",
})``;

export const ConfirmModalBodyText = styled.p.attrs({
  className: "text-sm leading-7 text-[var(--brand-muted)]",
})``;

export const ConfirmModalDangerButton = styled.button.attrs<{
  $tone: "default" | "danger";
}>(({ $tone }) => ({
  className: $tone === "danger" ? "brand-button-danger" : "brand-button",
}))`` as any;
